/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
  ApiPetAllergy,
  ApiPetAllergyFromJSON,
  ApiPetAllergyToJSON,
  ApiPetAttributeData,
  ApiPetAttributeDataFromJSON,
  ApiPetAttributeDataToJSON,
  ApiPetAvatar,
  ApiPetAvatarFromJSON,
  ApiPetAvatarToJSON,
  ApiPetBreed,
  ApiPetBreedFromJSON,
  ApiPetBreedToJSON,
  ApiPetMedicalCondition,
  ApiPetMedicalConditionFromJSON,
  ApiPetMedicalConditionToJSON,
  ApiPetMedication,
  ApiPetMedicationFromJSON,
  ApiPetMedicationToJSON,
  ApiPetMedicationAllergy,
  ApiPetMedicationAllergyFromJSON,
  ApiPetMedicationAllergyToJSON,
  ApiPetPrimaryDiscipline,
  ApiPetPrimaryDisciplineFromJSON,
  ApiPetPrimaryDisciplineToJSON,
  ApiPetRidingStyle,
  ApiPetRidingStyleFromJSON,
  ApiPetRidingStyleToJSON,
  ApiPetType,
  ApiPetTypeFromJSON,
  ApiPetTypeToJSON,
} from '../models';

export interface GetPetAvatarRequest {
  id: number;
}

export interface GetPetAvatarsRequest {
  petTypeId?: number;
}

export interface GetPetBreedsRequest {
  petTypeId?: number;
}

export interface GetPetPrimaryDisciplinesRequest {
  ridingStyle?: string;
}

/**
 *
 */
export class PetAttributeApi extends runtime.BaseAPI {
  /**
   * Get pet allergies
   * Get Pet Allergies
   */
  async getPetAllergiesRaw(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiPetAllergy>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-allergies`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiPetAllergyFromJSON),
    );
  }

  /**
   * Get pet allergies
   * Get Pet Allergies
   */
  async getPetAllergies(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiPetAllergy>> {
    const response = await this.getPetAllergiesRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get pet attribute data such as types, breeds, etc.
   * Get Pet Attribute Data
   */
  async getPetAttributeDataRaw(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiPetAttributeData>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-attribute-data`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiPetAttributeDataFromJSON(jsonValue),
    );
  }

  /**
   * Get pet attribute data such as types, breeds, etc.
   * Get Pet Attribute Data
   */
  async getPetAttributeData(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiPetAttributeData> {
    const response = await this.getPetAttributeDataRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get a pet avatar for a given avatar ID
   * Get Pet Avatar
   */
  async getPetAvatarRaw(
    requestParameters: GetPetAvatarRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiPetAvatar>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling getPetAvatar.',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-avatars/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiPetAvatarFromJSON(jsonValue));
  }

  /**
   * Get a pet avatar for a given avatar ID
   * Get Pet Avatar
   */
  async getPetAvatar(
    requestParameters: GetPetAvatarRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiPetAvatar> {
    const response = await this.getPetAvatarRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get pet avatars
   * Get Pet Avatars
   */
  async getPetAvatarsRaw(
    requestParameters: GetPetAvatarsRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiPetAvatar>>> {
    const queryParameters: any = {};

    if (requestParameters.petTypeId !== undefined) {
      queryParameters['petTypeId'] = requestParameters.petTypeId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-avatars`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiPetAvatarFromJSON),
    );
  }

  /**
   * Get pet avatars
   * Get Pet Avatars
   */
  async getPetAvatars(
    requestParameters: GetPetAvatarsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiPetAvatar>> {
    const response = await this.getPetAvatarsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get pet breeds
   * Get Pet Breeds
   */
  async getPetBreedsRaw(
    requestParameters: GetPetBreedsRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiPetBreed>>> {
    const queryParameters: any = {};

    if (requestParameters.petTypeId !== undefined) {
      queryParameters['petTypeId'] = requestParameters.petTypeId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-breeds`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiPetBreedFromJSON));
  }

  /**
   * Get pet breeds
   * Get Pet Breeds
   */
  async getPetBreeds(
    requestParameters: GetPetBreedsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiPetBreed>> {
    const response = await this.getPetBreedsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get pet medical conditions
   * Get Pet Medical Conditions
   */
  async getPetMedicalConditionsRaw(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiPetMedicalCondition>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-medical-conditions`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiPetMedicalConditionFromJSON),
    );
  }

  /**
   * Get pet medical conditions
   * Get Pet Medical Conditions
   */
  async getPetMedicalConditions(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiPetMedicalCondition>> {
    const response = await this.getPetMedicalConditionsRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get pet medication allergies
   * Get Pet Medication Allergies
   */
  async getPetMedicationAllergiesRaw(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiPetMedicationAllergy>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-medication-allergies`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiPetMedicationAllergyFromJSON),
    );
  }

  /**
   * Get pet medication allergies
   * Get Pet Medication Allergies
   */
  async getPetMedicationAllergies(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiPetMedicationAllergy>> {
    const response = await this.getPetMedicationAllergiesRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get pet medications
   * Get Pet Medications
   */
  async getPetMedicationsRaw(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiPetMedication>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-medications`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiPetMedicationFromJSON),
    );
  }

  /**
   * Get pet medications
   * Get Pet Medications
   */
  async getPetMedications(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiPetMedication>> {
    const response = await this.getPetMedicationsRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get pet primary disciplines
   * Get Pet Primary Disciplines
   */
  async getPetPrimaryDisciplinesRaw(
    requestParameters: GetPetPrimaryDisciplinesRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiPetPrimaryDiscipline>>> {
    const queryParameters: any = {};

    if (requestParameters.ridingStyle !== undefined) {
      queryParameters['ridingStyle'] = requestParameters.ridingStyle;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-primary-disciplines`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiPetPrimaryDisciplineFromJSON),
    );
  }

  /**
   * Get pet primary disciplines
   * Get Pet Primary Disciplines
   */
  async getPetPrimaryDisciplines(
    requestParameters: GetPetPrimaryDisciplinesRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiPetPrimaryDiscipline>> {
    const response = await this.getPetPrimaryDisciplinesRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get pet riding styles
   * Get Pet Riding Styles
   */
  async getPetRidingStylesRaw(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiPetRidingStyle>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-riding-styles`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApiPetRidingStyleFromJSON),
    );
  }

  /**
   * Get pet riding styles
   * Get Pet Riding Styles
   */
  async getPetRidingStyles(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiPetRidingStyle>> {
    const response = await this.getPetRidingStylesRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get pet types
   * Get Pet Types
   */
  async getPetTypesRaw(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<Array<ApiPetType>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/petprofile/v1/pet-types`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiPetTypeFromJSON));
  }

  /**
   * Get pet types
   * Get Pet Types
   */
  async getPetTypes(
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<Array<ApiPetType>> {
    const response = await this.getPetTypesRaw(initOverrides);
    return await response.value();
  }
}
